import { gql } from "graphql-request";

const SERVER_LOGIN_AS_COMPANY_BY_ID = gql`
  mutation SERVER_LoginAsCompany($companyId: ID) {
    simulateCompany(companyId: $companyId)
  }
`;
export default SERVER_LOGIN_AS_COMPANY_BY_ID;
